import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
export const useResyncQbo = _ref => {
  let {
    onSettled,
    isPaymentRecorded
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    mutate
  } = useMutationState({
    mutationFn: invoiceId => api.invoice.resyncQbo(invoiceId),
    mutationName: 'Resync QBO',
    withPageLoader: true,
    toasts: {
      successMessage: isPaymentRecorded ? 'Invoice and payment re-synced successfully' : 'Invoice re-synced successfully',
      errorMessage: 'Failed to resync'
    },
    onSettled
  });
  return {
    resyncQbo: mutate
  };
};